import { useContext, useState } from 'react';
import axios from 'axios';
import StoreContext from '../components/Store/context';
import useDebouncedPromise from './useDebouncedPromise';

const initialRequestInfo = {
  error: null,
  data: null,
  loading: false,
};

export const API_BASE_URL = 'https://duzz-commercial-api-pvh4nb26ja-uc.a.run.app'; // PRD
// export const API_BASE_URL = 'https://duzz-commercial-api-dev-500930429533.us-central1.run.app'; // HML
// export const API_BASE_URL = 'https://api.duzzsystem.com.br';
// export const API_BASE_URL = 'http://172.16.0.3:8080';
// export const API_BASE_URL = 'http://192.168.1.8:8080';

function notifyApiActivity(url) {
  // temp disable auto request
  return

  // if (!url || typeof url !== 'string') return;
  // // Não dispara se for a própria chamada do chatbot para evitar loop infinito
  // if (url.includes('/chatbot')) return;
  // if (typeof window !== 'undefined') {
  //   window.dispatchEvent(new CustomEvent('duzz:api_request_success'));
  // }
}

export async function callApi(config, credencials = null) {
  const finalConfig = {
    baseURL: API_BASE_URL,
    ...config,
    headers: {
      sessionToken: credencials && credencials.sessionToken,
      company: credencials && String(credencials.company),
      ...(config && config.headers),
    },
  };
  const response = await axios(finalConfig);
  notifyApiActivity(finalConfig.url);
  return response;
}

export default function useApi(config) {
  const [requestInfo, setRequestInfo] = useState(initialRequestInfo);
  const debouncedAxios = useDebouncedPromise(axios, config?.debounceDelay);
  const clearValues = () => setRequestInfo(initialRequestInfo);
  const { setOpenModal, setModalUpgradePlan, credencials } = useContext(StoreContext);

  async function call(localConfig) {
    setRequestInfo({
      ...initialRequestInfo,
      loading: true,
    });

    let response = null;

    const finalConfig = {
      baseURL: API_BASE_URL,
      ...config,
      ...localConfig,
      headers: {
        sessionToken: credencials && credencials.sessionToken,
        company: credencials && credencials.company,
        ...(config && config.headers),
        ...(localConfig && localConfig.headers),
      },
    };

    const fn = finalConfig.debounced ? debouncedAxios : axios;

    try {
      response = await fn(finalConfig);
      notifyApiActivity(finalConfig.url);
      setRequestInfo({
        ...initialRequestInfo,
        data: response.data,
      });
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.error
      ) {
        if (error.response.data.error.includes('O token fornecido é inválido.')) {
          setOpenModal(true);
        }
        if (error.response.data.error.includes('Plano insuficiente.')) {
          setModalUpgradePlan(true);
        }
      }
      setRequestInfo({
        ...initialRequestInfo,
        error,
      });
      if (localConfig && localConfig.onError) {
        localConfig.onError(error);
      }
      if (config.onError) {
        config.onError(error);
      }
    }
    if (localConfig && localConfig.onCompleted) {
      localConfig.onCompleted(response);
    }
    if (config.onCompleted) {
      config.onCompleted(response);
    }
    return response;
  }

  return [call, requestInfo, clearValues];
}
